module.exports = __webpack_public_path__ + "static/media/icon-play.8dee8e58.svg";